import { AssetDrawingsData, BaseFormData } from 'pages/reporting/shared/types'
import { TimeString } from 'types'

export interface Resolution {
  height: number
  width: number
  widthUnit: string
  heightUnit: string
  angles?: number
}

export type SensorSerialNumbers = Record<number, string[]>

export interface RobotData {
  model?: string
  serialNumber: string
}

export interface CalibrationBlock {
  type?: string
  serialNumber?: string
}

export interface CalibrationStep {
  stepName: string
  distance: {
    value: number
    unit: string
  }
}

export interface ComponentAxisStartLocation {
  xAxisStartLocation: string
  yAxisStartLocation: string
}

export interface MainInfo {
  assetName: string
  assetId: string
  assetType: string
  assetMaterial: string
  customerName: string
  customerLocation: string
  inspectionTemperature: string
  componentAxisStartLocations: Record<string, ComponentAxisStartLocation>
}

export interface CoverSectionData {
  inspectionStartDate: string
  inspectionEndDate: string
}

export interface SummarySectionData {
  inspectionResolution: Resolution
  deliverableResolution: Resolution
  coverageScope: string
  corrosionBLUF: string
  inspectionSummaryNotes?: string
  useTableForSummary?: boolean
}

export interface SensorDiameter {
  value: number
  unit: string
}

export interface SensorPayloadData {
  payloadType?: string
  sensorFrequency?: number
  sensorDiameter?: SensorDiameter
}

export interface DataSheetSectionData {
  sensorSerialNumbers: SensorSerialNumbers
  inspectionSurface: string
  surfaceCondition: string
  coatingPresent: boolean
  robots: RobotData[]
  calibrationBlocks: CalibrationBlock[]
  calibrationTimes: TimeString[]
  calibrationSteps: CalibrationStep[]
  procedure?: string
  procedureTitle?: string
  payloads?: SensorPayloadData[]
  inspectionSoftware?: string
}

export interface ImagesSectionData {
  imageReportIds: string[]
}

export interface SectionAddendum {
  sectionId: string
  pageSubtitle: string
  addedPageCount: number
  isCustomSection?: boolean
}

export interface RugFormDataState extends BaseFormData {
  mainInfo: MainInfo
  coverSectionData: CoverSectionData
  summarySectionData: SummarySectionData
  dataSheetSectionData: DataSheetSectionData
  imagesSectionData: ImagesSectionData
  assetDrawings: AssetDrawingsData
  sectionAddendums: SectionAddendum[]
}

export enum RugReportSectionId {
  COVER = 'cover',
  INTRO_TO_RUG = 'introToRUG',
  SUMMARY = 'summary',
  DATA_SHEET = 'dataSheet',
  DATA_OVERVIEW = 'dataOverview',
  IMAGES = 'images',
  RUG_DATA_IMAGES = 'rugDataImages',
  REVIEW = 'review',
  PDF_GENERATION = 'pdfGeneration',
  TABLE_OF_CONTENTS = 'tableOfContents',
  SECTION_ADDENDUMS = 'sectionAddendums',
}

export type RUGPrePopulatedData = Partial<
  Pick<
    MainInfo,
    | 'assetName'
    | 'assetId'
    | 'assetType'
    | 'customerName'
    | 'customerLocation'
    | 'assetMaterial'
    | 'inspectionTemperature'
    | 'componentAxisStartLocations'
  > &
    CoverSectionData &
    SummarySectionData &
    DataSheetSectionData
>
